import ajax from "../utils/request";

const productApi = {
  /********************************产品和订单管理*********************************** */
  /********************************VIP商品列表*********************************** */
  // VIP商品列表
  getPruductList(params) {
    return ajax({
      url: "/business/product/list",
      type: "get",
      params: params,
    });
  },
  // 新增栏目
  getNewSection(params) {
    return ajax({
      url: "/business/product",
      type: "post",
      params: params,
    });
  },
  // 编辑栏目
  getEditSection(params) {
    return ajax({
      url: "/business/product/update",
      type: "post",
      params: params,
    });
  },
  // 删除栏目
  getDeleteSection(params) {
    return ajax({
      url: "/business/product",
      type: "delete",
      params: params,
    });
  },
  /********************************VIP权益列表*********************************** */
  // VIP权益列表
  getProductBenefitList(params) {
    return ajax({
      url: "/productBenefit/list",
      type: "get",
      params: params,
    });
  },
  // 新增权益
  newProductBenefit(params) {
    return ajax({
      url: "/productBenefit/add",
      type: "post",
      params: params,
    });
  },
  // 编辑权益
  editProductBenefit(params) {
    return ajax({
      url: "/productBenefit/update",
      type: "post",
      params: params,
    });
  },
  // 删除权益
  deleteProductBenefit(params) {
    return ajax({
      url: "/productBenefit/del",
      type: "delete",
      params: params,
    });
  },
  /********************************金币列表*********************************** */
  // 新增金币
  addGold(params) {
    return ajax({
      url: "/recharge/gold/add",
      type: "post",
      params: params,
    });
  },
  // 获取金币配置列表
  getGoldList(params) {
    return ajax({
      url: "/recharge/gold/list",
      type: "get",
      params: params,
    });
  },
  // 修改金币配置
  updateGold(params) {
    return ajax({
      url: "/recharge/gold/update",
      type: "post",
      params: params,
    });
  },
  // 删除金币配置
  delGold(params) {
    return ajax({
      url: "/recharge/gold/delete",
      type: "delete",
      params: params,
    });
  },
  /********************************积分配置列表*********************************** */
  // 获取积分配置列表
  getIntegralConfigList(params) {
    return ajax({
      url: "/integral_config/list",
      type: "get",
      params: params,
    });
  },
  // 添加积分配置
  addIntegralConfig(params) {
    return ajax({
      url: "/integral_config/add",
      type: "post",
      params: params,
    });
  },
  // 修改积分配置
  updateIntegralConfig(params) {
    return ajax({
      url: "/integral_config/update",
      type: "post",
      params: params,
    });
  },
  /********************************游戏金币列表*********************************** */
  // 新增游戏金币
  addGameGold(params) {
    return ajax({
      url: "/recharge/game/gold/add",
      type: "post",
      params: params,
    });
  },
  // 获取游戏金币配置列表
  getGameGoldList(params) {
    return ajax({
      url: "/recharge/game/gold/list",
      type: "get",
      params: params,
    });
  },
  // 修改游戏金币配置
  updateGameGold(params) {
    return ajax({
      url: "/recharge/game/gold/update",
      type: "post",
      params: params,
    });
  },
  // 删除游戏金币配置
  delGameGold(params) {
    return ajax({
      url: "/recharge/game/gold/delete",
      type: "delete",
      params: params,
    });
  },

  /********************************货币列表*********************************** */
  // 新增货币
  addCurrency(params) {
    return ajax({
      url: "/currency",
      type: "post",
      params: params,
    });
  },
  // 获取货币配置列表
  getCurrencyList(params) {
    return ajax({
      url: "/currency",
      type: "get",
      params: params,
    });
  },
  // 修改货币配置
  updateCurrency(params, noFiltering) {
    return ajax(
      {
        url: "/currency",
        type: "put",
        params: params,
      },
      noFiltering
    );
  },

  /********************************金币优惠配置*********************************** */
  // 新增金币优惠配置
  addPayGold(params) {
    return ajax({
      url: "/gold/cfg/add",
      type: "post",
      params: params,
    });
  },
  // 获取金币支付配置列表
  getPayGoldList(params) {
    return ajax({
      url: "/gold/cfg/list",
      type: "get",
      params: params,
    });
  },
  // 编辑金币支付配置
  updatePayGold(params) {
    return ajax({
      url: "/gold/cfg/edit",
      type: "post",
      params: params,
    });
  },
  // 删除金币支付配置
  delPayGold(params) {
    return ajax({
      url: "/gold/cfg/del",
      type: "delete",
      params: params,
    });
  },
  /********************************推广落地页列表*********************************** */
  // 新增推广落地页
  addPromote(params) {
    return ajax({
      url: "/promoteUrl/insert",
      type: "post",
      params: params,
    });
  },
  // 获取推广落地页配置列表
  getPromoteList(params) {
    return ajax({
      url: "/promoteUrl/list",
      type: "get",
      params: params,
    });
  },
  // 修改推广落地页配置
  updatePromote(params) {
    return ajax({
      url: "/promoteUrl/update",
      type: "post",
      params: params,
    });
  },
  // 删除推广落地页配置
  delPromote(params) {
    return ajax({
      url: "/promoteUrl/delete",
      type: "delete",
      params: params,
    });
  },
  /********************************支付方式列表*********************************** */
  // 新增支付方式
  addChannel(params) {
    return ajax({
      url: "/recharge/channel/add",
      type: "post",
      params: params,
    });
  },
  // 获取支付方式配置列表
  getChannelList(params) {
    return ajax({
      url: "/recharge/channel/list",
      type: "get",
      params: params,
    });
  },
  // 修改支付方式配置
  updateChannel(params) {
    return ajax({
      url: "/recharge/channel/update",
      type: "post",
      params: params,
    });
  },
  // 删除支付方式配置
  delChannel(params) {
    return ajax({
      url: "/recharge/channel/delete",
      type: "delete",
      params: params,
    });
  },

  /********************************产品展示位置配置列表*********************************** */
  // 获取列表
  getPositionList(params) {
    return ajax({
      url: "/business/productPosition/list",
      type: "post",
      params: params,
    });
  },
  // 新增
  addPosition(params) {
    return ajax({
      url: "/business/productPosition/add",
      type: "post",
      params: params,
    });
  },
  // 编辑
  editPosition(params) {
    return ajax({
      url: "/business/productPosition/edit",
      type: "post",
      params: params,
    });
  },
  //删除
  deletePosition(params) {
    return ajax({
      url: "/business/productPosition/del",
      type: "post",
      params: params,
    });
  },
  // 产品展示位置
  getNames(params) {
    return ajax({
      url: "/business/productPosition/names",
      type: "post",
      params: params,
    });
  },
  /********************************VIP升级配置*********************************** */
  // 获取VIP升级配置信息
  getConfig(params) {
    return ajax({
      url: "/business/getConfig",
      type: "get",
      params: params,
    });
  },
  //编辑配置信息
  setConfig(params) {
    return ajax({
      url: "/business/setConfig",
      type: "post",
      params: params,
    });
  },
   /********************************官方下载管理*********************************** */
  // 官方下载管理列表
  getOfficialList(params) {
    return ajax({
      url: "/official/list",
      type: "get",
      params: params,
    });
  },
  // 新增官方下载
  addOfficial(params) {
    return ajax({
      url: "/official/add",
      type: "post",
      params: params,
    });
  },
  // 编辑官方下载
  updOfficial(params) {
    return ajax({
      url: "/official/update",
      type: "post",
      params: params,
    });
  },
  // 删除栏目
  delOfficial(params) {
    return ajax({
      url: "/official/delete",
      type: "delete",
      params: params,
    });
  },
  // 查询兑换列表
  integralExchange(params) {
    return ajax({
      url: "/integral_exchange",
      type: "get",
      params: params,
    });
  },
  /********************************banner活动管理*********************************** */
  // 获取banner活动列表
  getBannerjumpList(params) {
    return ajax({
      url: "/bannerjump/list",
      type: "get",
      params,
    });
  },
  // 新增banner活动
  addBannerjump(params) {
    return ajax({
      url: "/bannerjump/create",
      type: "post",
      params,
    });
  },
  // 修改banner活动
  updateBannerjump(params) {
    return ajax({
      url: "/bannerjump/update",
      type: "post",
      params,
    });
  },
  // 删除banner活动
  deleteBannerjump(params) {
    return ajax({
      url: "/bannerjump/delete",
      type: "post",
      params,
    });
  },
};

export default productApi;
